import { useEffect, useState } from "react";
import { Box, Stack, TextInput, Button, Title, Text, Alert } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setSession, verifyToken } from "@/lib/auth";

export default function Access() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const t = params.get("t");
    if (t) setToken(t);
    const errParam = params.get("error");
    if (errParam) setError(errParam);
  }, [params]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const session = await verifyToken(token.trim());
      setSession(session);
      navigate("/private", { replace: true });
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "unknown_error";
      if (msg.includes("_401")) setError("Token is invalid, revoked, or expired.");
      else setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Stack gap="lg" maw={480}>
      <Box>
        <Title order={1} className="iridescent-text">
          Access
        </Title>
        <Text c="dimmed" mt="xs">
          Paste your access token to view unreleased material.
        </Text>
      </Box>

      {error && (
        <Alert color="red" title="Couldn't verify">
          {error}
        </Alert>
      )}

      <form onSubmit={onSubmit}>
        <Stack gap="sm">
          <TextInput
            label="Token"
            placeholder="7md-xxxxxxxxxxxx"
            value={token}
            onChange={(e) => setToken(e.currentTarget.value)}
            required
            autoComplete="off"
          />
          <Button type="submit" loading={loading} color="indigo">
            Unlock
          </Button>
        </Stack>
      </form>

      <Text size="xs" c="dimmed">
        No token? Email{" "}
        <Text component="a" href="mailto:alex@7minutes.dev" c="var(--color-foam)">
          alex@7minutes.dev
        </Text>{" "}
        and request one!
      </Text>
    </Stack>
  );
}
